import { Skeleton } from 'antd';
import * as React from 'react';

import { SpacingRow, SpacingUnit } from '../../Spacing';

import s from './SkeletonPlaceholder.module.scss';

const SkeletonPlaceholder: React.FC = () => {
  return (
    <SpacingRow hSpacing={SpacingUnit.unit5}>
      {Array.from(Array(7)).map((_, index) => (
        <Skeleton.Button
          active
          block
          shape="default"
          className={s.skeletonPlaceholder}
          key={index}
        />
      ))}
    </SpacingRow>
  );
};

export default React.memo(SkeletonPlaceholder);
